import { useMutation, useQuery } from "urql";

const GET_HOLDING_FLOW = `
query GET_HOLDING_FLOW($companyIds: [String!]!, $currency: String!, $view: String, $showProjections: Boolean, $areaFilter: String!) {
    getHoldingCashFlow(
        companyIds: $companyIds,
        currency: $currency, 
        view: $view,
        showProjections: $showProjections
        areaFilter: $areaFilter,
    ) {
        id
        futureMonthsView
        name
        pastMonthsView
        periods {
            start
            end
            isPast
            view
        }
        primaryView
        report {
            INCOME {
                label
                cashflowCategoryId
                oldCategoryKey
                isIncome
                isTotal
                isDefault
                isVisible
                isHidden
                fields {
                    label
                    cashflowAreaId
                    isIncome
                    isVisible
                    isHidden
                    isDefault
                    values {
                        fieldValue
                        start
                        end
                        currency
                        flowView
                        isLate
                        isProjected
                        isPast
                        isTotal
                        isClickable
                        documents
                    }
                    companiesValues {
                        companyId
                        name
                        values {
                            fieldValue
                            start
                            end
                            currency
                            flowView
                            isLate
                            isProjected
                            isPast
                            isTotal
                            isClickable
                            documents
                        }
                        isVisible
                    }
                    mergedFrom
                    isMerged
                }
                values {
                    fieldValue
                    start
                    end
                    currency
                    flowView
                    isLate
                    isProjected
                    isPast
                    isTotal
                    isClickable
                    documents
                }
            }
            EXPENSE {
                label
                cashflowCategoryId
                oldCategoryKey
                isIncome
                isTotal
                isDefault
                isVisible
                isHidden
                fields {
                    label
                    cashflowAreaId
                    isIncome
                    isVisible
                    isHidden
                    isDefault
                    values {
                        fieldValue
                        start
                        end
                        currency
                        flowView
                        isLate
                        isProjected
                        isPast
                        isTotal
                        isClickable
                        documents
                    }
                    companiesValues {
                        companyId
                        name
                        values {
                            fieldValue
                            start
                            end
                            currency
                            flowView
                            isLate
                            isProjected
                            isPast
                            isTotal
                            isClickable
                            documents
                        }
                        isVisible
                    }
                    mergedFrom
                    isMerged
                }
                values {
                    fieldValue
                    start
                    end
                    currency
                    flowView
                    isLate
                    isProjected
                    isPast
                    isTotal
                    isClickable
                    documents
                }
            }
            RESUME {
                label
                cashflowCategoryId
                oldCategoryKey
                isIncome
                isTotal
                isDefault
                isHidden
                values {
                    fieldValue
                    start
                    end
                    currency
                    flowView
                    isLate
                    isProjected
                    isPast
                    isTotal
                    isClickable
                    documents
                }
            }
            TOTAL {
                label
                cashflowCategoryId
                oldCategoryKey
                isIncome
                isTotal
                isDefault
                isHidden
                fields {
                    label
                    cashflowAreaId
                    isIncome
                    isVisible
                    isHidden
                    isDefault
                    values {
                        fieldValue
                        start
                        end
                        currency
                        flowView
                        isLate
                        isProjected
                        isPast
                        isTotal
                        isClickable
                        documents
                    }
                }
                values {
                    fieldValue
                    start
                    end
                    currency
                    flowView
                    isLate
                    isProjected
                    isPast
                    isTotal
                    isClickable
                    documents
                }
            }
        }
    }
}
`;

export const GetHoldingFlow = ({ companyIds, currency, view, showProjections, areaFilter }) => {
    const [result, reexecuteHoldingFlow] = useQuery({
        query: GET_HOLDING_FLOW,
        variables: { companyIds, currency, view, showProjections, areaFilter },
    });
    const { data, fetching, error } = result;
    return { data, fetching, error, reexecuteHoldingFlow };
}


const GET_HOLDING_FLOW_STRUCTURE = `
query GET_HOLDING_FLOW_STRUCTURE($companyIds: [String!]!) {
    getHoldingFlowStructure(
        companyIds: $companyIds
    ) {
        futureMonthsView
        name
        pastMonthsView
        primaryView
        report {
            INCOME {
                label
                cashflowCategoryId
                oldCategoryKey
                isIncome
                isTotal
                isDefault
                isVisible
                isHidden
                fields {
                    label
                    cashflowAreaId
                    isIncome
                    isVisible
                    isHidden
                    isDefault
                    values {
                        fieldValue
                        start
                        end
                        currency
                        flowView
                        isLate
                        isProjected
                        isPast
                        isTotal
                        isClickable
                        documents
                    }
                    companiesValues {
                        companyId
                        name
                        values {
                            fieldValue
                            start
                            end
                            currency
                            flowView
                            isLate
                            isProjected
                            isPast
                            isTotal
                            isClickable
                            documents
                        }
                        isVisible
                    }
                    mergedFrom
                    isMerged
                }
                values {
                    fieldValue
                    start
                    end
                    currency
                    flowView
                    isLate
                    isProjected
                    isPast
                    isTotal
                    isClickable
                    documents
                }
            }
            EXPENSE {
                label
                cashflowCategoryId
                oldCategoryKey
                isIncome
                isTotal
                isDefault
                isVisible
                isHidden
                fields {
                    label
                    cashflowAreaId
                    isIncome
                    isVisible
                    isHidden
                    isDefault
                    values {
                        fieldValue
                        start
                        end
                        currency
                        flowView
                        isLate
                        isProjected
                        isPast
                        isTotal
                        isClickable
                        documents
                    }
                    companiesValues {
                        companyId
                        name
                        values {
                            fieldValue
                            start
                            end
                            currency
                            flowView
                            isLate
                            isProjected
                            isPast
                            isTotal
                            isClickable
                            documents
                        }
                            isVisible
                    }
                    mergedFrom
                    isMerged
                }
                values {
                    fieldValue
                    start
                    end
                    currency
                    flowView
                    isLate
                    isProjected
                    isPast
                    isTotal
                    isClickable
                    documents
                }
            }
            RESUME {
                label
                cashflowCategoryId
                oldCategoryKey
                isIncome
                isTotal
                isDefault
                isHidden
                values {
                    fieldValue
                    start
                    end
                    currency
                    flowView
                    isLate
                    isProjected
                    isPast
                    isTotal
                    isClickable
                    documents
                }
            }
            TOTAL {
                label
                cashflowCategoryId
                oldCategoryKey
                isIncome
                isTotal
                isDefault
                isHidden
                fields {
                    label
                    cashflowAreaId
                    isIncome
                    isVisible
                    isHidden
                    isDefault
                    values {
                        fieldValue
                        start
                        end
                        currency
                        flowView
                        isLate
                        isProjected
                        isPast
                        isTotal
                        isClickable
                        documents
                    }
                }
                values {
                    fieldValue
                    start
                    end
                    currency
                    flowView
                    isLate
                    isProjected
                    isPast
                    isTotal
                    isClickable
                    documents
                }
            }
        }
    }
}
`;

export const GetHoldingFlowStructure = ({ companyIds }) => {
    const [result, reExecuteQuery] = useQuery({
        query: GET_HOLDING_FLOW_STRUCTURE,
        variables: { companyIds },
    });
    const { data, fetching, error } = result;
    return { data, fetching, error, reExecuteQuery };
}

const MERGE_CATEGORY_AREAS = `
    mutation MERGE_CATEGORY_AREAS(
        $mergedAreaName: String!
        $targetCategoryId: String!
        $areaIdsToMerge: [String!]!
        $holdingFlowId: String!
    ) {
        mergeCategoryAreas(
            mergedAreaName: $mergedAreaName
            targetCategoryId: $targetCategoryId
            areaIdsToMerge: $areaIdsToMerge
            holdingFlowId: $holdingFlowId
        ){
            status
            message
            mergedAreaId
        }
    }
`;

export const MergeCategoryAreas = () => {
    const [result, executeMutation] = useMutation(MERGE_CATEGORY_AREAS);

    const { data, fetching, error } = result;
    return { data, fetching, error, executeMutation };
};

const UNMERGE_AREA = `
    mutation UNMERGE_AREA(
        $holdingFlowId: String!
        $mergedAreaId: String!
    ) {
        unmergeArea(
            holdingFlowId: $holdingFlowId
            mergedAreaId: $mergedAreaId
        ) {
            status
            message
            mergedAreaId
        }
    }
`;

export const UnmergeArea = () => {
    const [result, executeMutation] = useMutation(UNMERGE_AREA);

    const { data, fetching, error } = result;
    return { data, fetching, error, executeMutation };
};

const UPDATE_MERGED_AREA = `
    mutation UPDATE_MERGED_AREA(
        $holdingFlowId: String!
        $mergedAreaId: String!
        $targetCategoryId: String!
        $newName: String!
        $newAreaIds: [String!]!
    ) {
        updateMergedArea(
            holdingFlowId: $holdingFlowId
            mergedAreaId: $mergedAreaId
            targetCategoryId: $targetCategoryId
            newName: $newName
            newAreaIds: $newAreaIds
        ) {
            status
            message
            mergedAreaId
        }
    }
`;

export const UpdateMergedArea = () => {
    const [result, executeMutation] = useMutation(UPDATE_MERGED_AREA);

    const { data, fetching, error } = result;
    return { data, fetching, error, executeMutation };
};